
export const useGridSection = () => {
  const getFutureMonthsEdit = () => {
    const arr: { label: string; dateString: string }[] = [];
    const dt = new Date();
    const startMonth = dt.getMonth();
    const startYear = dt.getFullYear();
    const monthShortHand = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];

    for (let i = 0; i < 15; i++) {
      const month = (startMonth + i + 1) % 12;
      const year = startYear + Math.floor((startMonth + i + 1) / 12);
      arr.push({
        label: `${monthShortHand[month]}-${year}`,
        dateString: `${year}-${month >= 9 ? month + 1 : `0${month + 1}`}-01`,
      });
    }

    return arr;
  };
  const forecastingMonthsEdit: { label: string; dateString: string }[] = getFutureMonthsEdit();

  return {
    forecastingMonthsEdit,
  };
};
